import { useCallback, useRef, useState } from 'react';
export const useAutoplay = ({
  autoplay
}, setIsTouchActive) => {
  const sliderRef = useRef();
  const timeout = useRef();
  const [mouseOver, setMouseOver] = useState(false);
  const clearNextTimeout = useCallback(() => clearTimeout(timeout.current), []);
  const nextTimeout = useCallback(() => {
    clearNextTimeout();
    if (!mouseOver && sliderRef.current?.track.details != null) {
      timeout.current = setTimeout(() => sliderRef.current?.next(), autoplay?.interval);
    }
  }, [autoplay?.interval, clearNextTimeout, mouseOver]);
  const onMouseOver = useCallback(() => {
    setMouseOver(true);
    clearNextTimeout();
  }, [clearNextTimeout]);
  const onMouseOut = useCallback(() => {
    setMouseOver(false);
    nextTimeout();
  }, [nextTimeout]);
  const onTouchStart = useCallback(() => {
    setIsTouchActive(true);
    setMouseOver(true);
    clearNextTimeout();
  }, [clearNextTimeout, setIsTouchActive]);
  const onTouchEnd = useCallback(() => {
    setIsTouchActive(false);
    setMouseOver(false);
    nextTimeout();
  }, [nextTimeout, setIsTouchActive]);
  const plugin = useCallback(slider => {
    sliderRef.current = slider;
    sliderRef.current.on('created', instance => {
      const parent = instance.container.parentElement;
      parent?.addEventListener('mouseover', onMouseOver);
      parent?.addEventListener('touchstart', onTouchStart);
      parent?.addEventListener('mouseout', onMouseOut);
      parent?.addEventListener('touchend', onTouchEnd);
      nextTimeout();
    });
    sliderRef.current.on('animationEnded', nextTimeout);
    sliderRef.current.on('destroyed', instance => {
      const parent = instance.container.parentElement;
      parent?.removeEventListener('mouseover', onMouseOver);
      parent?.removeEventListener('touchstart', onTouchStart);
      parent?.removeEventListener('mouseout', onMouseOut);
      parent?.removeEventListener('touchend', onTouchEnd);
      sliderRef.current = undefined;
    });
  }, [nextTimeout, onMouseOut, onMouseOver, onTouchEnd, onTouchStart]);
  return autoplay?.enabled ? plugin : undefined;
};
//# sourceMappingURL=useAutoplay.js.map